/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Leadership_TitleInputs */

const en_landing_leadership_title = /** @type {(inputs: Landing_Leadership_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leadership & advisory`)
};

/**
* | output |
* | --- |
* | "Leadership & advisory" |
*
* @param {Landing_Leadership_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_leadership_title = /** @type {((inputs?: Landing_Leadership_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Leadership_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_leadership_title(inputs)
});